module.exports = __webpack_public_path__ + "media/images/emblems/Zuoz_wappen-b83f5d048e1f32eab084cdb6a7de7440.svg";